import { numberInputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, cssVar } from '@chakra-ui/styled-system';
import { sizes as sizes$1, baseStyle as baseStyle$1, defaultProps } from './input.js';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(numberInputAnatomy.keys);
const sizes = {
  xl: {
    root: sizes$1.xl.field
  },
  lg: {
    root: sizes$1.lg.field
  },
  md: {
    root: sizes$1.md.field
  },
  sm: {
    root: sizes$1.sm.field
  },
  xs: {
    root: sizes$1.xs.field
  }
};
const $inputFontSize = cssVar("input-font-size");
const baseStyle = {
  ...baseStyle$1,
  root: {
    height: "max-content",
    fontSize: $inputFontSize.reference
  },
  stepper: {
    _disabled: { display: "none" },
    color: "inherit",
    px: "0.25em",
    // half input padding
    borderRadius: "0.25em",
    _dark: {
      color: "inherit"
    },
    _hover: {
      bgColor: "slate.100",
      _dark: {
        bgColor: "lightBlueAlpha.300"
      }
    },
    _active: {
      bgColor: "slate.100",
      _dark: {
        bgColor: "lightBlueAlpha.500"
      }
    },
    svg: {
      height: "0.6em",
      width: "0.6em"
    }
  },
  stepperGroup: {
    _disabled: { display: "none" },
    mr: "0.25em"
    // half input padding
  }
};
let NumberInput = defineMultiStyleConfig({
  baseStyle,
  sizes,
  // @ts-ignore - Added 'status' property, not a default Chakra prop, a convention from Iris
  defaultProps
});

export { NumberInput };
